import { createWidget } from '@alfa-bank/site-util-create-widget';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { TimeChips as Component } from './time-chips';
import type { IDeps, TTimeChips } from './models';
import styles from './styles/styles.css';

export const TimeChipsDesktop = createWidget<IDeps, TTimeChips>({ styles, Text: TextDesktop })(
    Component
);
